import { isFeatureEnabled } from 'owa-feature-flags';
import { attachmentPreviewOperations } from 'owa-mail-attachment-previews';
import { lazyFetchCouponData } from 'owa-mail-coupon-peek';
import { TableView } from 'owa-mail-list-store';
import getSelectedTableViewId from 'owa-mail-list-store/lib/utils/getSelectedTableViewId';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { lazyTryPrefetchMeetingMessage } from 'owa-listview-rsvp';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Fetch RichContentForRows on the tableview
 * @param tableView to perform the operation on
 */
export default function fetchRichContentForRows(tableView: TableView) {
    const listViewType = tableView.tableQuery.listViewType;
    if (getUserConfiguration().UserOptions.ShowInlinePreviews) {
        // Get the attachment previews
        attachmentPreviewOperations.getPreviews(getMailboxInfo(tableView), listViewType);
    }

    if (isFeatureEnabled('tri-coupon-peek')) {
        lazyFetchCouponData.import().then(fetchCouponData => {
            fetchCouponData(getMailboxInfo(tableView).deprecatedMailboxId, listViewType);
        });
    }

    if (
        isFeatureEnabled('tri-meetingMessageRSVP') ||
        isFeatureEnabled('tri-meetingMessageRSVPExp')
    ) {
        lazyTryPrefetchMeetingMessage.importAndExecute(
            getMailboxInfo(tableView),
            listViewType,
            tableView.id !== getSelectedTableViewId() //should delay prefetch
        );
    }
}
